import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ReactTooltip from "react-tooltip";
import * as DOMPurify from 'dompurify';

import { myUtilities } from "../../Utils";

class InvoiceCompleteGridDataRow extends React.Component {
  displayToolTip = (data) => {
    if (
      data === undefined ||
      data === null ||
      data.toString().localeCompare("null") === 0
    )
      return null;
    if (data.length > 13)
      return (
        <ReactTooltip
          id={"completegridtooltip" + this.props.index + data}
          className="tooltip"
          place="bottom"
          type="dark"
          effect="solid"
        >
          <span>{this.formatDataForToolTip(data)}</span>
        </ReactTooltip>
      );
  };

  formatDataForToolTip = (data) => {
    let formattedData = "";
    const formatLength = 20;
    if (data.length < formatLength) return data;
    while (data.length !== 0) {
      formattedData += data.substring(0, formatLength) + "\u000D\u000A";
      data = data.substring(formatLength, data.length);
    }
    return formattedData;
  };

  getLengthBasedOnScreenWidth = () => {
    let width = window.screen.width;
    if (width > 767) return 13;
    else if (width > 575) return 11;
    else return 9;
  };

  formatData = (data) => {
    if (
      data === undefined ||
      data === null ||
      data.toString().localeCompare("null") === 0
    )
      return "";
    let length = this.getLengthBasedOnScreenWidth();
    if (data.length > length) {
      return data;
    } else return data;
  };

  onMouseOver = (data) => {
    let length = this.getLengthBasedOnScreenWidth();
    if (data.length > length) {
      document
        .getElementById(this.props.index + data)
        .classList.add("tooltip-test");
      document
        .getElementById(this.props.index + data)
        .setAttribute("data-content", this.formatDataForToolTip(data));
      if (this.props.index < 20)
        document
          .getElementById(this.props.index + data)
          .classList.add("tooltip-margin-top");
      else
        document
          .getElementById(this.props.index + data)
          .classList.add("tooltip-margin-bottom");
    }
  };

  onMouseOut = (data) => {
    let length = this.getLengthBasedOnScreenWidth();
    if (data.length > length) {
      document
        .getElementById(this.props.index + data)
        .classList.remove("tooltip-test");
      document
        .getElementById(this.props.index + data)
        .classList.remove("tooltip-margin-top");
      document
        .getElementById(this.props.index + data)
        .classList.remove("tooltip-margin-bottom");
    }
  };

  partialFieldRenderers = {
    payableAmount: (data, invoice, accountDocHeaderId, invoiceData) => (
      <input
        type="number"
        min="0"
        step="0.01"
        value={data}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => invoiceData.updateInvoicePartialPayment(accountDocHeaderId, 'payableAmount', e.target.value)}
        style={{ width: '100%', border: '1px solid #ccc', borderRadius: '3px', padding: '2px 4px' }}
      />
    ),
    partialPaymentReason: (data, invoice, accountDocHeaderId, invoiceData, isFullPayment) => (
      <div>
        {invoiceData.state.twoLevelReasonCodeEnabled && (
          <select
            value={invoice?.partialPaymentReasonCategory || ''}
            disabled={isFullPayment}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              const val = e.target.value;
              invoiceData.updateInvoicePartialPayment(accountDocHeaderId, 'partialPaymentReasonCategory', val);
              invoiceData.updateInvoicePartialPayment(accountDocHeaderId, 'partialPaymentReason', '');
              invoiceData.fetchReasonCodes(val);
            }}
            style={{ width: '100%', border: '1px solid #ccc', borderRadius: '3px', padding: '2px 4px', marginBottom: '4px' }}
          >
            <option value="">Select Category</option>
            {(invoiceData.state.reasonCategories || []).map((r, idx) => (
              <option key={idx} value={r.value}>{r.displayName}</option>
            ))}
          </select>
        )}
        <select
          value={invoice?.partialPaymentReason || ''}
          disabled={isFullPayment}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => invoiceData.updateInvoicePartialPayment(accountDocHeaderId, 'partialPaymentReason', e.target.value)}
          style={{ width: '100%', border: '1px solid #ccc', borderRadius: '3px', padding: '2px 4px' }}
        >
          <option value="">Select Reason</option>
          {(invoiceData.state.reasonCodes || []).map((r, idx) => (
            <option key={idx} value={r.value}>{r.displayName}</option>
          ))}
        </select>
      </div>
    ),
    partialPaymentComments: (data, invoice, accountDocHeaderId, invoiceData) => (
      <input
        type="text"
        value={invoice?.partialPaymentComments || ''}
        placeholder="Comments"
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => invoiceData.updateInvoicePartialPayment(accountDocHeaderId, 'partialPaymentComments', e.target.value)}
        style={{ width: '100%', border: '1px solid #ccc', borderRadius: '3px', padding: '2px 4px' }}
      />
    ),
  };

  displayRow = (isFullPayment) => {
    let invoiceData = this.props.invoiceData;
    let fields = this.props.fields;
    if (fields !== undefined) {
      let columns = new Array();
      let invoice = invoiceData.state.invoices?.[this.props.index];
      let accountDocHeaderId = invoice?.accountDocHeaderId;
      let partialEnabled = invoiceData.state.partialPaymentEnabledForGuestPay === true;
      for (let i = 0; i < fields.length; ++i) {
        let fieldKey = fields[i][0];
        let data = invoiceData.validateAndPopulateInvoiceData(
          this.props.index,
          fieldKey,
          17,
          "complete"
        );
        if (partialEnabled && this.partialFieldRenderers[fieldKey]) {
          columns.push(
            <td key={this.props.index + fieldKey}>
              {this.partialFieldRenderers[fieldKey](data, invoice, accountDocHeaderId, invoiceData, isFullPayment)}
            </td>
          );
        } else {
          columns.push(
            <td
              id={this.props.index + data}
              onMouseOut={() => this.onMouseOut(myUtilities.toStringUtil(data))}
              onMouseOver={() => this.onMouseOver(myUtilities.toStringUtil(data))}
              key={this.props.index + data}
            >
              {myUtilities.needCurrency(fieldKey) +
                this.formatData(myUtilities.toStringUtil(data, fieldKey))}
            </td>
          );
        }
      }
      return columns;
    }
  };
  render() {
    let { selectedIndices, index, clickHandler, invoiceData } = this.props;
    const invoice = invoiceData.state.invoices?.[this.props.index];
    if (!invoice) return null;
    const originalAmt = parseFloat(
      invoice.payableAmount2 !== undefined
        ? invoice.payableAmount2
        : (invoice.invoiceAmount || invoice.payableAmount)
    );
    const currentAmt = parseFloat(invoice.payableAmount);

    // Returns true if edited amount equals or exceeds full amount
    const isFullPayment = Number.isNaN(currentAmt) || currentAmt >= originalAmt;
    return (
      <tr
        onClick={() => clickHandler(index)}
      	className={
              selectedIndices.includes(index)
                ? "invoice-complete-grid-row-selected"
                : "invoice-complete-grid-row"
         }
        key={invoiceData.state.invoices[index].accountDocHeaderId}
      >
        <td style={{ paddingLeft: '10px',paddingRight:'10px' }}>
          <div>
            <input
              checked={selectedIndices.includes(index)}
              type="checkbox"
              value="1"
              id="checkboxOneInput"
              name=""
            />
            <label for="checkboxOneInput"></label>
          </div>
        </td>
        {this.displayRow(isFullPayment)}
      </tr>
    );
  }
}

export default InvoiceCompleteGridDataRow;
